module.exports = __webpack_public_path__ + "7518e0765637913f0e1511108e404589.svg";